import { useTranslation } from 'react-i18next';

import './RosterSortToggle.css';

export type RosterSortMode = 'raid' | 'mythicPlus';

/**
 * A real sliding switch, not two separately-highlighted buttons — the thumb
 * physically moves to whichever side is active, so the current filter is
 * unambiguous even at a glance.
 */
export function RosterSortToggle({
  mode,
  onChange,
}: {
  mode: RosterSortMode;
  onChange: (mode: RosterSortMode) => void;
}) {
  const { t } = useTranslation();

  return (
    <div className="roster-sort-toggle" role="radiogroup" aria-label={t('roster.sortHint')}>
      <span
        className={`roster-sort-toggle-thumb roster-sort-toggle-thumb-${mode}`}
        aria-hidden="true"
      />
      <button
        type="button"
        role="radio"
        aria-checked={mode === 'raid'}
        className={mode === 'raid' ? 'roster-sort-toggle-active' : ''}
        onClick={() => onChange('raid')}
      >
        {t('roster.sortByRaid')}
      </button>
      <button
        type="button"
        role="radio"
        aria-checked={mode === 'mythicPlus'}
        className={mode === 'mythicPlus' ? 'roster-sort-toggle-active' : ''}
        onClick={() => onChange('mythicPlus')}
      >
        {t('roster.sortByMythicPlus')}
      </button>
    </div>
  );
}
